// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__204Il","selects":"Documents_selects__JH_lN"};